import {Box, Divider, Stack, Typography, useTheme} from "@mui/material";
import ScrollAnimation from "react-animate-on-scroll";
import AllergensList from "./AllergensList";

const ProductItem = (props) => {
    const theme = useTheme();

    return <>
        <ScrollAnimation animateIn='fadeInUp' offset={50}>
            <Stack
                direction='row'
                alignItems='center'
                sx={{
                    py: 1,
                    px: 1
                }}
            >
                <Stack direction='column' sx={{flexGrow: 1}}>
                    <Stack direction='row' pr={1} sx={{
                        alignItems: 'center',
                    }}>
                        <Typography
                            variant='h5'
                            textAlign='left'
                            color='primary'
                        >
                            {props.name}
                        </Typography>
                        <AllergensList allergens={props.allergens} />
                    </Stack>
                    <Typography
                        variant='body2'
                        textAlign='left'
                        sx={{
                            minHeight: '48px'
                        }}>
                        {props.description}
                    </Typography>
                </Stack>
                <Box>
                    <Typography variant='h5' color='secondary' fontSize='1.4rem'>
                        {props.price}
                    </Typography>
                </Box>
            </Stack>
            <Divider variant='middle' sx={{borderColor: theme.palette.brLight.dark}} />
        </ScrollAnimation>
    </>
}

export default ProductItem;